<template>
  <div style="width: 100%;height: 100%;background-color: white">
    <div style="height: 20px"></div>
    <div style="height: calc(100% - 20px);width: 100%;overflow-y: auto">
    <el-row style="height: 100%;">
      <el-col :span="24" style="height: 100%;overflow-y: auto">
        <div style="float: left">
          <el-button type="primary" plain icon="el-icon-plus" @click="addRelation()">新建</el-button>&nbsp;&nbsp;
          <el-input
            prefix-icon="el-icon-search"
            placeholder="按电话、房号搜索"
            v-model="searchKeyword"
            style="width: 350px"
            clearable>
          </el-input>&nbsp;
        </div>
        <div style="clear: both"></div>
        <div style="margin-top: 10px;">
          <el-table
            v-loading="loading"
            :data="tbdata"
            border
            style="width: 100%"
            highlight-current-row
            ref="singleTable">
            <el-table-column
              type="index"
              label="序号"
              width="50"
            align="center">
            </el-table-column>
            <el-table-column
              prop="address"
              label="房号"
              min-width="85"
              align="left">
            </el-table-column>
            <el-table-column
              v-if="moduletag === 1"
              label="所属小区"
              min-width="80"
              align="center">
              <template slot-scope="scope">
                <span>{{getOnCommunity(scope.row)}}</span>
              </template>
            </el-table-column>
            <el-table-column
              v-else-if="moduletag === 2"
              label="所属机构"
              min-width="80"
              align="center">
              <template slot-scope="scope">
                <span>{{getOnCommunity(scope.row)}}</span>
              </template>
            </el-table-column>
            <el-table-column
              v-else
              label="所属小区/机构"
              min-width="80"
              align="center">
              <template slot-scope="scope">
                <span>{{getOnCommunity(scope.row)}}</span>
              </template>
            </el-table-column>
            <el-table-column
              prop="telephone"
              label="联系方式"
              min-width="80"
              align="center">
            </el-table-column>
            <el-table-column
              label="所属组织"
              min-width="80"
              align="center">
              <template slot-scope="scope">
                <span>{{getOnOrg(scope.row)}}</span>
              </template>
            </el-table-column>
            <el-table-column
              prop="createtime"
              label="录入时间"
              min-width="110"
              align="center">
            </el-table-column>
            <el-table-column align="center" label="操作" width="90">
              <template slot-scope="scope">
<!--                <i class="el-icon-user-solid" style="cursor: pointer; font-size: 18px;color: blue" @click="seeOtherOldPerson(scope.row)"></i>-->
                <i title="编辑" class="el-icon-edit" style="cursor: pointer; font-size: 18px;color: #1ae517" @click="editRelation(scope.row)"></i>
                <i title="删除" class="el-icon-delete" style="cursor: pointer; font-size: 18px;color: red" @click="delRelation(scope.row)"></i>
              </template>
            </el-table-column>
          </el-table>
        </div>
        <div style="margin-top: 10px;height: 40px;text-align: center">
          <el-pagination v-fixZoom
            @size-change="handleSizeChange"
            @current-change="handleCurrentChange"
            :current-page="currentPage"
            :page-sizes="[10, 20, 50, 100]"
            :page-size="pageSize"
            layout="total, sizes, prev, pager, next, jumper"
            :total="totalCells">
          </el-pagination>
        </div>
      </el-col>
    </el-row>
    </div>
    <!--created-->
    <el-dialog
      :visible.sync="addShow"
      v-if="addShow"
      width="800px"
      :show-close="true"
      :close-on-click-modal="false"
      center
      top="10vh"
      append-to-body
      class="all-open">
      <relation-add :homeAddRow="addRow" v-model="addShow"></relation-add>
    </el-dialog>
    <!--update-->
    <el-dialog
      :visible.sync="editShow"
      v-if="editShow"
      width="800px"
      :show-close="true"
      :close-on-click-modal="false"
      center
      top="10vh"
      append-to-body
      class="all-open">
      <div class="title-top-alarm">
        <div>
          <span>{{homeName}}</span>
        </div>
        <div class="line-title"></div>
      </div>
      <relation-edit :relationEditRow="editRow" v-model="editShow"></relation-edit>
    </el-dialog>
    <!--联系人-->
    <el-dialog
      :title="familyTitle"
      :visible.sync="familyShow"
      v-if="familyShow"
      :close-on-click-modal="false"
      width="900px"
      top="10vh"
      center
      append-to-body>
      <family-old-person :familyData="familyShowData" v-model="familyShow"></family-old-person>
    </el-dialog>
  </div>
</template>

<script>
import relationAdd from './childComponents/relationAdd'
import relationEdit from './childComponents/relationEdit'

import {queryorghome, deleteorghome} from '../../api/relation'
import {queryoldperson} from '../../api/serviceObject'
import community from './community'
import familyOldPerson from './childComponents/familyOldPerson'
export default {
  name: 'relation',
  components: {relationAdd, relationEdit, community, familyOldPerson},
  props: {
    communityData: {
      type: Object,
      default: null
    }
  },
  data () {
    return {
      isShangHai: true,
      // 左边
      filterText: '',
      orgData: [],
      searchKeyword: '',
      treeData: [],
      expandedKeys: [],
      isFirst: [],
      // 右边
      orgid: '',
      oldpersons: [],
      openOldPersons: [],
      familyTitle: '',
      familyShowData: {
        row: {},
        oldPersons: []
      },
      familyShow: false,
      orgcommunitys: [],
      tableData: [],
      showTable: [],
      loading: false,
      pageSize: 10,
      currentPage: 1,
      totalCells: 0,
      addShow: false,
      addRow: {
        homeTitle: '新建家庭/机构',
        cid: '',
        orgcommunitys: [],
        orgid: '',
        orgids: [],
        orgTree: [],
        // row为小区查看家庭小区信息
        row: '',
        isAll: false
      },
      editShow: false,
      editRow: {
        orgcommunitys: [],
        row: {},
        orgTree: [],
        orgids: []
      },
      // 小区/机构
      community: false,
      row: '',
      moduletag: '',
      homeName: '更新家庭'
    }
  },
  created () {
    this.isShangHai = this.$store.state.user.isShangHai
    this.moduletag = this.$store.state.user.moduletag
    // console.log(23456789, this.communityData)
    this.orgid = this.$store.state.user.orgid
    this.isFirst = this.communityData.orgId
    this.orgData = this.communityData.orgData
    this.orgcommunitys = this.communityData.orgcommunitys
    this.addRow.orgcommunitys = this.communityData.orgcommunitys
    this.editRow.orgcommunitys = this.communityData.orgcommunitys
    this.golobleObject.updateTableHome = this.getQueryOrgHome1
    this.row = this.communityData.row
    this.addRow.row = this.communityData.row
    this.addRow.isAll = this.communityData.isAll
    this.addRow.orgTree = this.communityData.orgData
    if (this.row.zone_type === 1) {
      this.homeName = '更新家庭'
      this.addRow.homeTitle = '新建家庭'
    } else if (this.row.zone_type === 2) {
      this.homeName = '更新房间'
      this.addRow.homeTitle = '新建房间'
    } else {
      this.homeName = '更新家庭/房间'
      this.addRow.homeTitle = '新建家庭/房间'
    }
    // console.log(this.addRow.homeTitle)
    this.editRow.orgTree = this.communityData.orgTree
    this.getQueryOrgHome()
  },
  mounted () {
  },
  computed: {
    tbdata () {
      return this.searchFilterWord()
    }
  },
  watch: {
  },
  methods: {
    // 表格
    getQueryOrgHome () {
      this.loading = true
      let isTime = this.communityData.orghomes.length / this.pageSize
      if (isTime !== parseInt(isTime)) {
        isTime = parseInt(isTime) + 1
      }
      if (isTime < this.currentPage) {
        if (this.currentPage !== 1) {
          this.currentPage -= 1
        }
      }
      this.tableData = this.communityData.orghomes
      this.getOldPerson()
    },
    getQueryOrgHome1 () {
      queryorghome().then(res => {
        this.$emit('fatherCommunity', res.data.orghomes)
        let isTime = res.data.orghomes.length / this.pageSize
        if (isTime !== parseInt(isTime)) {
          isTime = parseInt(isTime) + 1
        }
        if (isTime < this.currentPage) {
          if (this.currentPage !== 1) {
            this.currentPage -= 1
          }
        }
        let arr = []
        if (!this.addRow.isAll) {
          for (let i = 0; i < res.data.orghomes.length; i++) {
            if (this.row.id === res.data.orghomes[i].cid) {
              arr.push(res.data.orghomes[i])
            }
          }
        } else {
          arr = res.data.orghomes
        }
        this.tableData = arr
        this.getEndTable()
        // this.loading = false
      }).catch(() => {
        this.loading = false
      })
    },
    // 服务对象
    getOldPerson () {
      this.loading = true
      let data = {
        orgid: this.orgid
      }
      queryoldperson(data).then(res => {
        this.loading = false
        this.oldpersons = res.data.oldpersons
        this.getEndTable()
      }).catch(() => {
        this.getEndTable()
        this.loading = false
      })
    },
    getEndTable () {
      this.showTable = []
      if (this.isFirst.length === 0) {
        this.showTable = this.tableData
      } else {
        for (let i = 0; i < this.tableData.length; i++) {
          if (this.isFirst.indexOf(this.tableData[i].orgid) > -1) {
            this.showTable.push(this.tableData[i])
          }
        }
      }
    },
    // table数据入口（tbdata）
    searchFilterWord () {
      const data = this.showTable
      const vm = this
      const search = data.filter((val) => {
        if (val.telephone.includes(vm.searchKeyword) || val.address.includes(vm.searchKeyword)) {
          return true
        }
      })
      vm.totalCells = search.length
      const arr = []
      for (let i = (vm.currentPage - 1) * vm.pageSize; i < vm.currentPage * vm.pageSize; i++) {
        if (!search[i]) {
          break
        }
        arr.push(search[i])
      }
      return arr
    },
    getOnOrg (row) {
      for (let i = 0; i < this.orgData.length; i++) {
        if (row.orgid === this.orgData[i].id) {
          return this.orgData[i].name
        }
      }
    },
    getOnCommunity (row) {
      for (let i = 0; i < this.orgcommunitys.length; i++) {
        if (row.cid === this.orgcommunitys[i].id) {
          return this.orgcommunitys[i].name
        }
      }
    },
    // 查看小区/机构
    seeCommunity () {
      this.community = true
    },
    // 新建关系
    addRelation () {
      this.addShow = true
    },
    // 编辑关系
    editRelation (row) {
      this.editRow.row = row
      this.editShow = true
    },
    // 删除关系
    delRelation (row) {
      let name = row.name
      if (this.row.zone_type === 1) {
        name = '家庭'
      } else if (this.row.zone_type === 2) {
        name = '房间'
      } else {
        name = '家庭/房间'
      }
      this.$confirm('此操作将永久删除该' + name + ', 是否继续?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'error'
      }).then(() => {
        let data = {
          homeids: [row.id]
        }
        deleteorghome(data).then(() => {
          this.getQueryOrgHome1()
          this.$notify({
            title: '成功',
            message: '删除家庭成功',
            type: 'success',
            duration: 2000
          })
        }).catch(() => {
          this.$notify.error({
            title: '失败',
            message: '删除家庭失败'
          })
        })
      }).catch(() => {})
    },
    seeOtherOldPerson (row) {
      if (this.moduletag === 1) {
        this.familyTitle = '家庭成员'
      } else if (this.moduletag === 2) {
        this.familyTitle = '机构成员'
      } else if (this.moduletag === 3) {
        this.familyTitle = '家庭/机构成员'
      } else {
        this.familyTitle = '成员'
      }
      this.familyShowData.row = row
      this.familyShowData.oldPersons = []
      for (let i = 0; i < this.oldpersons.length; i++) {
        if (row.id === this.oldpersons[i].homeid) {
          this.familyShowData.oldPersons.push(this.oldpersons[i])
        }
      }
      this.familyShow = true
    },
    handleSizeChange (val) {
      this.pageSize = val
    },
    handleCurrentChange (val) {
      this.currentPage = val
    }
  }
}
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/components/datamanagement/relation.vue